import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title?: string
  subtitle?: string
}

export const TourSummaryCard = ({ title, subtitle }: Props) => {
  return (
    <div className={s.container}>
      <h6 className={clsx(s.title, 'semi-bold-14')}>{title}</h6>
      <p className={clsx(s.subtitle, 'regular-12')}>{subtitle}</p>
    </div>
  )
}
